export const voucherConstants = {
    SELECT_VOUCHER: 'SELECT_VOUCHER',
    SELECTED_VOUCHER_LIST: 'SELECTED_VOUCHER_LIST',
    GET_VOUCHERS: 'GET_VOUCHERS',
    GET_VOUCHERS_SUCCESS: 'GET_VOUCHERS_SUCCESS',
    GET_VOUCHERS_FAILURE: 'GET_VOUCHERS_FAILURE',
    
    // Voucher redemption constants
    GET_VOUCHER_BY_CODE: 'GET_VOUCHER_BY_CODE',
    GET_VOUCHER_BY_CODE_SUCCESS: 'GET_VOUCHER_BY_CODE_SUCCESS',
    GET_VOUCHER_BY_CODE_FAILURE: 'GET_VOUCHER_BY_CODE_FAILURE',
    
    GET_VOUCHER_BY_REDEMPTION_CODE: 'GET_VOUCHER_BY_REDEMPTION_CODE',
    GET_VOUCHER_BY_REDEMPTION_CODE_SUCCESS: 'GET_VOUCHER_BY_REDEMPTION_CODE_SUCCESS',
    GET_VOUCHER_BY_REDEMPTION_CODE_FAILURE: 'GET_VOUCHER_BY_REDEMPTION_CODE_FAILURE',
    
    UPDATE_VOUCHER_BALANCE: 'UPDATE_VOUCHER_BALANCE',
    UPDATE_VOUCHER_BALANCE_SUCCESS: 'UPDATE_VOUCHER_BALANCE_SUCCESS',
    UPDATE_VOUCHER_BALANCE_FAILURE: 'UPDATE_VOUCHER_BALANCE_FAILURE',
    
    // New voucher operations
    ISSUE_VOUCHER: 'ISSUE_VOUCHER',
    ISSUE_VOUCHER_SUCCESS: 'ISSUE_VOUCHER_SUCCESS',
    ISSUE_VOUCHER_FAILURE: 'ISSUE_VOUCHER_FAILURE',
    
    REDEEM_VOUCHER: 'REDEEM_VOUCHER',
    REDEEM_VOUCHER_SUCCESS: 'REDEEM_VOUCHER_SUCCESS',
    REDEEM_VOUCHER_FAILURE: 'REDEEM_VOUCHER_FAILURE',
    
    VOID_VOUCHER: 'VOID_VOUCHER',
    VOID_VOUCHER_SUCCESS: 'VOID_VOUCHER_SUCCESS',
    VOID_VOUCHER_FAILURE: 'VOID_VOUCHER_FAILURE',
    
    UPDATE_VOUCHER_REDEMPTION: 'UPDATE_VOUCHER_REDEMPTION',
    UPDATE_VOUCHER_REDEMPTION_SUCCESS: 'UPDATE_VOUCHER_REDEMPTION_SUCCESS',
    UPDATE_VOUCHER_REDEMPTION_FAILURE: 'UPDATE_VOUCHER_REDEMPTION_FAILURE',
};